import { AHInput, AHInputProps, AHText } from "arkh";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export function WidgetSettingsTitleInput(props: {
  staticTitle?: string;
  title: AHInputProps["value"];
  setTitle: AHInputProps["onChangeText"];
}) {
  const intl = useIntl();
  return (
    <>
      <AHText spaceBottom="small" spaceHorizontal="medium" type="body">
        <FormattedMessage
          defaultMessage="Widget title"
          description="WidgetSettingsTitleInput: label"
        />
      </AHText>
      <AHInput
        keyboardType="default"
        placeholder={intl.formatMessage({
          defaultMessage: "Title...",
          description: "WidgetSettingsTitleInput: placeholder",
        })}
        textType="title-small"
        defaultStyle
        value={props.title}
        onChangeText={props.setTitle}
      />
    </>
  );
}
